// In your App.js or routing file
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PaymentSuccessRedirect from './components/PaymentSuccessRedirect';

function App() {
  return (
    <Router>
      <Routes>
        {/* Other routes */}
        <Route 
          path="/payment-success/:orderId" 
          element={<PaymentSuccessRedirect />} 
        />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;
